import { Box, Grid, Typography, Button } from "@material-ui/core";
import styled from "@emotion/styled";

import Image from "next/image";

import intercom from "@/services/intercom";
import { useIsMobile } from "@/styles/breakpoints";
import { ButtonLink } from "@/components/Buttons/";
import Links from "@/constants/Links";

const NavLink = styled(ButtonLink)`
  color: #fff;
  font-size: 18px;
  text-transform: none;
  text-align: center;
`;

const NavButton = styled(Button)`
  color: #fff;
  font-size: 18px;
  text-transform: none;
  text-align: center;
`;

const Container = styled(Box)`
  background: linear-gradient(to right, #000, #133a57);
`;

export default function Footer() {
  const isMobile = useIsMobile();
  return (
    <Container color="#fff" py={4} px={2}>
      <Grid container spacing={2} alignItems="center" justifyContent="space-around">
        <Grid item xs={12} sm={6} lg={2}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box width={36} height={42} mr={1}>
              <Image
                src="/images/getcyber-logo-light.png"
                alt="Getcyber.com"
                height={60}
                width={50}
              />
            </Box>
            <Box>
              <Typography style={{ fontSize: 18 }}>
                <span>GETCYBER</span>
                <span style={{ color: "#2B33FF" }}>.COM</span>
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Box
            margin="auto"
            mt={isMobile ? 4 : 0}
            maxWidth={400}
            display="flex"
            justifyContent="center"
          >
            <Typography style={{ fontSize: 14 }}>
              GetCyber is offered by Lightsail Insurance Services, a licensed
              Property & Casualty insurance agency in all 50 states and D.C.
            </Typography>
          </Box>
        </Grid>
        <Grid item container>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Box display="flex" justifyContent="center" mt={isMobile ? 4 : 0}>
              <NavLink route={Links.WHAT_IS_CYBER_INSURANCE} variant="text">
                What is Cyber Insurance?
              </NavLink>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Box display="flex" justifyContent="center" mt={isMobile ? 4 : 0}>
              <NavButton onClick={intercom.show}>Contact</NavButton>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Box display="flex" justifyContent="center" mt={isMobile ? 4 : 0}>
              <NavLink route={Links.PRIVACY_POLICY} variant="text">
                Privacy Policy
              </NavLink>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Box display="flex" justifyContent="center" mt={isMobile ? 4 : 0}>
              <NavLink route={Links.ToS} variant="text">
                Terms and Conditions
              </NavLink>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
